import { fetch, Method, getPaging } from '../fetch';

const BASE_URL = '/api/v1.1.1/experience/';
const getBaseUrl = (experienceId) => `${BASE_URL}${experienceId}/experience_detail`;

const ExperienceDetailRoutes = {
    get: (experienceId, options) => `${getBaseUrl(experienceId)}?searchTerm=${options?.searchTerm}${options?.statusFilter !== 'all' ? `&status=${options?.statusFilter}` : ''}&${getPaging(options)}`,
    update: (experienceId, experienceDetailId) => `${getBaseUrl(experienceId)}/${experienceDetailId}`,
    create: (experienceId) => `${getBaseUrl(experienceId)}`,
};

export const ExperienceDetailService = {
    get: async (experienceId, options) => {
        try {
            const { data } = await fetch(ExperienceDetailRoutes.get(experienceId, options), {
                method: Method.GET,
                authenticated: true,
            });

            return data;
        } catch (error) {
            throw error;
        }
    },

    update: async (experienceId, experienceDetailId, values) => {
        try {
            const { data } = await fetch(ExperienceDetailRoutes.update(experienceId, experienceDetailId), {
                method: Method.PATCH,
                authenticated: true,
                data: values,
            });

            return data;
        } catch (error) {
            throw error;
        }
    },

    create: async (experienceId, values) => {
        try {
            const { data } = await fetch(ExperienceDetailRoutes.create(experienceId), {
                method: Method.POST,
                authenticated: true,
                data: values,
            });

            return data;
        } catch (error) {
            throw error;
        }
    },
};
